/**
 * WeaponHUD - Displays current weapon and health in the game HUD
 */

import { WeaponType, WEAPON_CONFIGS } from '../systems/WeaponSystem';

export class WeaponHUD {
  private weaponDisplay: HTMLElement | null;
  private healthDisplay: HTMLElement | null;
  private livesValue: HTMLElement | null;
  private gameHud: HTMLElement | null;
  private currentWeapon: WeaponType = WeaponType.WAVE_CANNON;

  constructor() {
    this.weaponDisplay = document.getElementById('weaponDisplay');
    this.healthDisplay = document.getElementById('healthDisplay');
    this.livesValue = document.getElementById('livesValue');
    this.gameHud = document.getElementById('gameHud');
    // Disable DOM-based HUD (use canvas HUD instead). Hide any existing elements so
    // the top-left cyan popup (weapon/score DOM) does not appear.
    try {
      if (this.weaponDisplay) this.weaponDisplay.style.display = 'none';
      if (this.healthDisplay) this.healthDisplay.style.display = 'none';
      if (this.livesValue) this.livesValue.style.display = 'none';
      if (this.gameHud) this.gameHud.style.display = 'none';
    } catch (e) {
      // ignore DOM errors in non-browser envs
    }
  }

  public updateWeapon(weaponType: WeaponType): void {
    this.currentWeapon = weaponType;
    if (!this.weaponDisplay) return;
    
    const config = WEAPON_CONFIGS[this.currentWeapon];
    
    // Update border and text color to match weapon
    this.weaponDisplay.style.borderColor = config.color;
    this.weaponDisplay.style.color = config.color;
    
    // Default weapon (Love Wave) has smaller, more subtle effects
    if (weaponType === WeaponType.WAVE_CANNON) {
      this.weaponDisplay.style.textShadow = `0 0 3px ${config.color}`;
      this.weaponDisplay.style.boxShadow = `0 0 5px ${config.color}`;
    } else {
      this.weaponDisplay.style.textShadow = `0 0 6px ${config.color}, 0 0 12px ${config.color}`;
      this.weaponDisplay.style.boxShadow = `0 0 10px ${config.color}`;
    }
    
    // Update weapon name
    this.weaponDisplay.innerHTML = `🔫 ${config.name.toUpperCase()}`;
  }

  public updatePowerUps(powerUps: Map<string, number>): void {
    // Powerups are now shown in Kid Kelly messages
    // Could add visual indicators here if needed
  }
  
  public updateHealth(lives: number): void {
    if (this.livesValue) {
      this.livesValue.textContent = lives.toString();
    }
  }

  public show(): void {
    // No-op: DOM HUD is disabled in favor of canvas HUD
  }

  public hide(): void {
    // No-op
  }
}
